import React from 'react';
import ReactSelect, { components } from 'react-select';
import {FormattedMessage, IntlShape} from 'react-intl';

import Highlighter from 'react-highlight-words';
import {Mixin as FormsyMixin} from 'formsy-react';
import ComponentMixin from 'formsy-react-components/release/mixins/component';
import {Row} from 'formsy-react-components';
import * as Instanced from '../../standalone/instanceHelper';
import Token from '../../../packages/extension/src/background/Token';

import './SearchableSelect.scss';
import { getLocale } from '../locales';
import SafeHTML from '../fw/SafeHTML.react';

// eslint-disable-next-line
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable react/prop-types */

let SelectBox = React.createClass({
    displayName: 'Select',

    mixins: [FormsyMixin, ComponentMixin],

    getInitialState () {
        return {
            isInstanced: Instanced.isInstanced(),
            loadingInstancedFunc: false,
            loading: Instanced.isInstanced(),
            fetching: false,
            fetched: false,
            error: false,
            fetch: null,
            fetchedValues: null,
            lastDatiQUery: this.props.datiQuery,
        };
    },

    componentDidMount: function () {
        setTimeout(() => {
            this.setState({
                fetching: true,
                loading: true,
            });
        });

        this.startFetch().then(() => {
            this.setState({
                fetched: true,
                loading: false,
            });

        }).catch(() => {
            this.setState({
                loading: false,
                error: true,
            });
        });
    },

    startFetch: function () {
        let promises = [];

        let datiQuery = this.props.datiQuery;
        let organisationId = this.props.organisation_id;
        let channelId = this.props.channel_id;
        let flowId = this.props.flow_id;

        let error = (e) => {
            this.setState({
                error: true,
                errorMessage: e ? e.message : undefined,
                loading: false,
                'lastDatiQUery': this.props.datiQuery,
            });
        };

        if (!organisationId) {
            error();
            throw new Error("Missing organisation_id for datiQuery: " + datiQuery);
        }
        if (!channelId) {
            error();
            throw new Error("Missing channel_id for datiQuery: " + datiQuery);
        }

        let url = "/api/v1/datiquery?query=" + encodeURIComponent(datiQuery) + "&organisationId=" + encodeURIComponent(organisationId || '') + "&channelId=" + encodeURIComponent(channelId || '') + "&flowId=" + encodeURIComponent(flowId || '') + "&locale=" + encodeURIComponent(getLocale());

        if (this.props.args && typeof this.props.args === 'object') {
            for (let argKey in this.props.args) {
                url += "&args[" + encodeURIComponent(argKey) + "]=" + encodeURIComponent(this.props.args[argKey]);
            }
        }

        let promise;
        if (this.props.fetchingCache[url]) {
            promise = this.props.fetchingCache[url];
        } else {
            promise = this.props.fetchingCache[url] = fetch(url, {
                headers: {
                    "Authorization": "Bearer " + Token.get(),
                }
            }).catch((e) => {
                error(e);
            }).then((result) => {
                return result.json();
            }).catch((e) => {
                error(e);
            });
        }

        promises.push(
            promise.then((json) => {
                if (json.error) {
                    return error(new Error(json.userError || json.errorMessage));
                }

                if (!('data' in json) && json.message) {
                    return error(new Error(json.message));
                }

                let values = [];
                let value = this.getValue();
                let hasValue = false;

                for (let row of json.data) {
                    let name = row['label'] || row['name'] || row["com.dativery.model.sharedFields.name@name"] || row["com.dativery.model.sharedFields.companyName@companyName"];
                    if (row["code"]) {
                        name = row["code"] + ": " + name;
                    } else if (row["code2"]) {
                        name = row["code2"] + ": " + name;
                    }

                    let key = row["code"] || row["value"] || String(row.key);

                    values.push({
                        label: name,
                        value: key,
                    });

                    if (String(value) === String(key)) {
                        hasValue = true;
                    }
                }

                if (this.props.multiple) {
                    if (!Array.isArray(value)) {
                        if (typeof value === 'string') {
                            value = value.split(",");
                        } else {
                            value = [value];
                        }
                    }

                    if (Array.isArray(value) && value.length !== 0) {
                        for (let val of value) {
                            if (values.findIndex((a) => String(a.value) === String(val)) === -1) {
                                values.unshift({
                                    label: val + " (Hodnota v seznamu chybí)",
                                    value: val,
                                });
                            }
                        }
                    }
                } else {
                    if (!hasValue && value !== null && value !== undefined && value !== "") {
                        values.unshift({
                            label: value + " (Hodnota v seznamu chybí)",
                            value: value,
                        });
                    }
                }


                if (!this.props.required && !this.props.multiple) {
                    values.unshift({
                        label: "-",
                        value: "",
                    });
                }

                if (this.props.onValuesFetched) {
                    values = this.props.onValuesFetched(values);
                }

                this.setState({
                    'fetchedValues': values,
                    'lastDatiQUery': this.props.datiQuery,
                });
            }).catch((e) => {
                error(e);
            })
        );

        return Promise.all(promises);
    },

    changeValue: function changeValue(item) {
        if (this.props.multiple) {
            let list = item.map((a) => a.value);
            this.setValue(list);
            this.props.onChange(this.props.name, list);
        } else {
            if (item && item.value !== undefined) {
                this.setValue(item.value);
                this.props.onChange(this.props.name, item.value);
            } else {
                throw new Error('Unsuspect selected item: ' + JSON.stringify(item) + ', All options: ' + JSON.stringify(this.props.options));
            }
        }
    },

    changeValueText: function changeValue(event) {
        this.setValue(event.target.value);
        this.props.onChange(this.props.name, event.target.value);
    },

    inputValue: function inputValue(item) {
        this.setState({inputValue: item || ''});
    },

    render: function render() {
        if (this.state.lastDatiQUery !== this.props.datiQuery) {
            this.componentDidMount();
        }

        if (this.state.isInstanced && this.state.loading) {
            if (!this.state.loadingInstancedFunc) {
                setTimeout(() => {
                    if (this.__isMounted) {
                        this.setState({
                            loadingInstancedFunc: true
                        });
                    }
                });

                Instanced.getInstanceHelper().then((funcs) => {
                    this.instanceFuncs = funcs;

                    if (this.__isMounted) {
                        this.setState({
                            loadingInstancedFunc: false,
                            loading: false
                        });
                    }
                }).catch(() => {});
            }

            return null;
        }

        if (this.getLayout() === 'elementOnly') {
            return this.renderElement();
        }

        return React.createElement(
            Row,
            _extends({}, this.getRowProperties(), {
                htmlFor: this.getId()
            }),
            this.renderElement(),
            this.renderHelp(),
            this.renderErrorMessage()
        );
    },

    /**
     * @override Select.renderElement
     */
    renderElement: function renderElement() {
        let passProps = JSON.parse(JSON.stringify(this.props));
        let className = passProps.className || '';
        let options = passProps.options || [];
        let htmlHelp = null;
        let help = null;

        if (passProps.htmlHelp) {
            htmlHelp = <span className="help-block"><SafeHTML value={passProps.htmlHelp + '<br/>'} /></span>;
        } else if (passProps.help) {
            help = <span className="help-block">{passProps.help}</span>;
        }

        delete passProps.id;
        delete passProps.value;
        delete passProps.onChange;
        delete passProps.disabled;
        delete passProps.className;
        delete passProps.htmlHelp;
        delete passProps.help;
        delete passProps.options;

        let self = this;

        if (this.state.isInstanced && this.instanceFuncs && this.instanceFuncs.SearchableSelectRenderElement) {
            return this.instanceFuncs.SearchableSelectRenderElement.call(this, passProps);
        }

        let loading = false;

        if (this.state.fetchedValues) {
            options = this.state.fetchedValues;
        } else {
            className += ' datiquery-loading ';
            loading = true;
        }

        let component;
        if (this.state.error || loading) {
            component = (<input
                className={className + " form-control"}
                disabled={this.isFormDisabled() || this.props.disabled}
                id={this.getId()}
                onChange={this.changeValueText}
                ref={el => {self.element = el;}}
                type="text"
                value={this.getValue()}
            />);
        } else {
            let currentValue = this.getValue();
            if (this.props.multiple) {
                currentValue = this.getValue().map((val) => options.find((a) => String(a.value) === String(val)));
            } else {
                currentValue = options.find((a) => String(a.value) === String(currentValue));
            }

            component = (<ReactSelect
                className={"searchable-select " + (className || '')}
                components={{ Option: (props) => {
                    if (this.state.inputValue && this.state.inputValue !== '') {
                        return (
                            <components.Option {...props}>
                                <Highlighter searchWords={[this.state.inputValue]} textToHighlight={props.data.label} />
                            </components.Option>
                        );
                    }

                    return <components.Option {...props} />;
                }}}
                id={this.getId()}
                isClearable={false}
                isDisabled={this.isFormDisabled() || this.props.disabled}
                isMulti={this.props.multiple}
                isSearchable
                onChange={this.changeValue}
                onInputChange={this.inputValue}
                options={options}
                ref={el => {self.element = el;}}
                styles={{
                    menu: (provided, state) => ({
                        ...provided,
                        'z-index': 100,
                    }),
                }}
                value={currentValue}
                {...passProps}
            />);
        }

        if (this.state.error) {

            return <div id={this.getId()}><div style={{position: "relative"}}><div style={{position: "absolute", "top": ".7em", "left": "-30px"}}><span className="fa fa-exclamation" style={{marginRight: '.3em', color: 'red'}}/></div><div>{component}{this.state.errorMessage ? <small style={{color: "red"}}><FormattedMessage defaultMessage="Error:" id="error"/> {this.state.errorMessage}</small> : null} {help}{htmlHelp}</div></div></div>;
        }

        if (loading) {
            return <div id={this.getId()}><div style={{position: "relative"}}><div style={{position: "absolute", "top": ".7em", "left": "-30px"}}><span className="fa fa-spin fa-refresh" style={{marginRight: '.3em'}}/></div><div>{component}{help}{htmlHelp}</div></div></div>;
        }

        return (<div id={this.getId()}>{component}{help}{htmlHelp}</div>);
    }
});

export default SelectBox;
